<script setup lang="ts">
import { EColors, type Colors } from '@/types/constants/ColorValues'
import type { Direction } from '@/types/constants/Direction'

type Props = {
    label?: string
    type?: Colors
    required?: boolean
    message?: string
    direction?: Direction
}

withDefaults(defineProps<Props>(), { type: EColors.PRIMARY, direction: 'row' })
</script>

<template>
    <b-field
        :label="label ? `${label}${label && required ? '*' : ''}` : undefined"
        label-position="on-border"
        :type="`is-${message ? EColors.DANGER : type}`"
        class="field-type"
        v-bind:message="message"
        v-bind="$attrs">
        <slot />
    </b-field>
</template>

<style lang="scss">
.field-type {
    color: $primary;
}
.field.is-floating-label .label {
    color: $primary;
}
</style>
